import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyBMcEHaWWqJU2_DvSTjYx8bfG3C5idu_DI",
  authDomain: "tramites-uap.firebaseapp.com",
  projectId: "tramites-uap",
  storageBucket: "tramites-uap.appspot.com",
  messagingSenderId: "131960180805",
  appId: "1:131960180805:web:7c2d8b70815a4b0b6b932c",
  measurementId: "G-5ZK1HMFEHW",
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);

let messaging = null;
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging();
    console.log("FCM habilitado");
  } else {
    console.warn("Este navegador no soporta Firebase Messaging");
  }
});

export const requestForToken = () => {
  return getToken(messaging, { vapidKey: `BKZGwrZSpcKwV8J1IiOKlCuYqaITfT1FtOP7k06fvVmldLENuZMTfEeUj-xYrfVJ-F2oydiAhIib0xUWSnURxQU` })
    .then((currentToken) => {
      if (currentToken) {
        //console.log('current token for client: ', currentToken);
        // Perform any other neccessary action with the token
        return currentToken;
      } else {
        // Show permission request UI
        console.warn("No se pudo obtener el token de notificación.");
        return null;
      }
    })
    .catch((err) => {
      console.error("Error al obtener el token:", err.message);
      if (err.code === "messaging/permission-blocked") {
        console.log("Las notificaciones están bloqueadas. Activa los permisos en la configuración del navegador.");
      }
      return null;
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
